var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loggingOut)?_c('div',[_vm._v(" You are currently logging out. ")]):_c('div',[_vm._v(" Somethings wrong ")])
}
var staticRenderFns = []

export { render, staticRenderFns }